import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl} from '@angular/forms';
import { Validators } from '@angular/forms';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";
// import { CountryISO } from 'ngx-intl-tel-input';

declare var $;
declare var gtag;
declare var fbq;


@Component({
  selector: 'app-franchisee-form',
  templateUrl: './franchisee-form.component.html',
  styleUrls: ['./franchisee-form.component.css']
})
export class FranchiseeFormComponent implements OnInit {

  public faaaa = new FormControl();
  cityList:any=[];
  keyword = 'name';
  initialValue:any;

  constructor(private fb : FormBuilder,private service:AppService,private router: Router) { }

  ngOnInit() {
    if(environment.production){
      this.service.sendEvents("Completefranchisee-form", "franchisee-form", "Franchisee-Form");

      fbq('track', "CompleteFranchisee-Form" , {
        content_type: "franchisee-form",
        content_title: this.router.url,
      });
    }

    this.service.post('/getCityNameByState',{state_id:33}).subscribe((data:any)=>{

      if(data[0].error == 0){
        this.cityList=data[0].result;

        this.initialValue = this.service.getSelectedCity.name;
        $("#like").hide();
      }

    })


    this.service.setTitle('Franchise Registration Form | Propira');
    this.service.setMetaTags({ property: "og:type", content: 'Property' });
    this.service.setMetaTags({ property: "og:title", content: 'Franchise Registration Form | Propira' });
    this.service.setMetaTags({ name: "keywords", content: 'Franchise Registration Form | Propira' });
    this.service.setMetaTags({ name: "description", content: 'Franchise Registration Form | Propira' });
    this.service.setMetaTags({ property: "og:description", content: 'Franchise Registration Form | Propira' }); 
  }

  franchiseeloader:boolean = false;
  requestSubmit:boolean = false;
  imageArray=[];
  regisAttachemnt:any;
  regisAttachemntName:string;
  fileSource = [];
  defaultPhoneCode = {initialCountry: 'in'};

  frenchieserequest = this.fb.group({
    company_name:['',[Validators.pattern('^[a-zA-Z ]*$')]],
    owner_name:['',[Validators.pattern('^[a-zA-Z ]*$')]],
    // no_employee:['',[Validators.required]],
    // registration_no:['',Validators.required],
    working_experience:['',[Validators.required]],
    office_address:['',[Validators.required]],
    contact_no:['',[Validators.required]],
    mail_id:['',[Validators.required,Validators.email]],
    // office_image:['',Validators.required],
    phone_code:['+91'],
    city_id:['',Validators.required]
  })


  // documentSubmit(event){
  //   if (event.target.files && event.target.files[0]) {
  //     if (!event.target.files[0].name.match(/.(docx|pdf|jpg|jpeg|png|gif)$/i)) {

  //       this.service.messageBox('failed', 'File must be Pdf/docx format.'); 

  //     }else{

  //       this.regisAttachemnt = event.target.files[0];
  //       this.regisAttachemntName=event.target.files[0].name;
  //       this.frenchieserequest.patchValue({'registration_no': this.regisAttachemnt});
  //     }
      
  //   }
  // }

  getCity(event:any){

    if(event != ""){
      $("#like").hide();
    }

    this.frenchieserequest.controls['city_id'].setValue(event.id);

  }

  CityInputFocused(){
    $("#like").show();
  }

  requestEnd(){
    if(this.frenchieserequest.valid){
      this.franchiseeloader = true ;
      // const imageData = new FormData();
      // imageData.append("type", "Web");
      // imageData.append("auth_token", this.service.getAuthorizationToken());

        var data = this.frenchieserequest.value;
        const franchiseeForm = new FormData();
        Object.keys(data).forEach((key) => {
          franchiseeForm.append(key, data[key]);
        });

        this.service.postMultipart('/franchiseRequest', franchiseeForm).subscribe((data:any)=>{
 
          if(data[0].error){

            this.service.messageBox('failed', data[0].msg);
            this.franchiseeloader = false ;
          }else{

            // this.imageArray=[];
            // this.regisAttachemnt=[];
            // this.regisAttachemntName="";
            this.frenchieserequest.reset();
            this.defaultPhoneCode = {initialCountry: 'in'};
            
            this.service.messageBox('success', data[0].msg);
            this.requestSubmit = false ;
            this.franchiseeloader = false;
          }
      },
      error => {
        window.scroll(0,0);
        this.service.messageBox('failed', error.errorDesc);
      });
      }else{

        this.requestSubmit = true;
      }

      // if(this.fileSource.length>0){

      //   for (var j = 0; j < this.fileSource.length; j++) {

      //     imageData.append("images[]", this.fileSource[j], this.fileSource[j].name);

      //   }

      //   this.service.postMultipart("/uploadFranchiseImage", imageData).subscribe((data:any)=>{

      //     if(data[0].error>0){

      //       this.service.messageBox('failed', data[0].msg);

      //     }else{

      //       // upload franchisee data

      //       this.frenchieserequest.patchValue({'office_image': data[0].images });

            
      //       franchiseeForm.append('registration_no',this.regisAttachemnt); 
          
      //     }
      //   },
      //   error => {
      //     this.service.messageBox('failed', error.errorDesc);
      //   });

      // }else{

      //   this.service.messageBox('failed', 'Please upload atleast one image.');
      // } 

    

  }

  // uploadFranchiseImage(event){
  //   var totalPropertyImageLength = this.imageArray.length;

  //   if (event.target.files.length + totalPropertyImageLength > 10) {

  //     this.service.messageBox('failed', 'You can upload max 10 images only');

  //   } else {
      
  //     if (event.target.files && event.target.files[0]) {
  //       var files = event.target.files;
  //       var filesAmount = event.target.files.length;
  //       for (let i = 0; i < filesAmount; i++) {

  //         if (!files[i].name.match(/.(jpg|jpeg|png|gif)$/i)) {

  //           this.service.messageBox('failed', 'Invalid image found in selected image.');

  //         } else {
            
  //           var reader = new FileReader(); 
  //           this.fileSource.push(files[i]);
  //           reader.onload = (event: any) => {
  //             this.imageArray.push(event.target.result);
  //           };

  //           reader.readAsDataURL(event.target.files[i]);
  //           this.frenchieserequest.patchValue({"office_image": event.target.files[i]});
  //         }
  //       }
  //     }
  //   }
  // }

  // deleteImage(imageId: any) {
  //   var array = this.fileSource;
  //   var imagePreviewUrl = this.imageArray;
  //   this.fileSource = [];
  //   this.imageArray = [];
  //   this.frenchieserequest.get("office_image").reset();
  //   if (array.length > 0) {
  //     for (var i = 0; i < array.length; i++) {
  //       if (i != imageId) {
  //         this.imageArray.push(imagePreviewUrl[i]);
  //         this.fileSource.push(array[i]);
  //         this.frenchieserequest.patchValue({ office_image: this.fileSource});
  //       }
  //     }
  //   }
  // } 

}